export const generate6RandomChars = (): string => {
  return Math.random().toString(36).substring(2, 8)
}
